export const Module = {
  ACCOUNTING: 'accounting',
  ANNOUNCEMENT: 'announcement',
  API: 'api',
  ASSET: 'asset',
  AUTH: 'auth',
  BILLING: 'billing',
  DOCUMENT: 'document',
  ESIGN: 'esign',
  ESTATE: 'estate',
  ESTATE_ACCOUNTING_QUEBEC_DISTRIBUTION: 'estate-accounting-quebec-distribution',
  EXPORT: 'export',
  FINANCIAL_ACCOUNT: 'financial-account',
  FINANCIAL_GATEWAY: 'financial-gateway',
  GUIDE: 'guide',
  INBOX: 'inbox',
  LIABILITY: 'liability',
  MEETING: 'meeting',
  NAV: 'nav',
  NOTIFICATION: 'notification',
  PREDEFINED: 'predefined',
  PROFESSIONAL: 'professional',
  ROLE: 'role',
  TEAM: 'team',
  TRUSTPILOT: 'trustpilot',
  UI: 'ui',
  USER: 'user'
};

export const FileExtension = {
  CSV: '.csv',
  DOC: '.doc',
  DOCX: '.docx',
  HTML: '.html',
  JPEG: '.jpeg',
  JPG: '.jpg',
  JSON: '.json',
  ODS: '.ods',
  PDF: '.pdf',
  PNG: '.png',
  POTX: 'potx',
  PPT: '.ppt',
  TSV: '.tsv',
  XLS: '.xls',
  XLSX: '.xlsx'
};

export const InternalUrls = {
  TALK_TO_SETTLE_EXPERT_URL: 'https://info.clearestate.com/talk-to-settlement-expert',
  CLEAR_ESTATE_A_SIMPLE_SOLUTION_BLOG_URL:
    'https://www.clearestate.com/blog/clearestate-a-simple-solution-for-difficult-times',
  CHECKOUT_AGENT_FOR_EXECUTOR_ADDENDUM_URL:
    'https://info.clearestate.com/agent-for-executor-addendum',
  SUBMIT_FEEDBACK_URL: 'https://info.clearestate.com/submit-your-feedback',
  CLEAR_ESTATE_WEBSITE: 'https://www.clearestate.com',
  ESTATE_UPSELL_PLAN_URL: 'https://www.clearestate.com/products/in-app-estate-planning-executors',
  CALIFORNIA_COUNTY_SPECIFIC_FILING_PROCESS:
    'https://doc.clickup.com/10531418/d/h/a1cju-21262/bc80c33593161f3/a1cju-30122',
  IG_PARTNERSHIOP_REFERRAL_URL:
    'https://www.clearestate.com/partners/can-ig-advisor-help-centre#training'
};

export const ExternalUrls = {
  ORGANISATION_REGISTRATION_NUMBER_HELP_SITE:
    'https://apps.cra-arc.gc.ca/ebci/hacc/srch/pub/dsplyBscSrch?request_locale=en',
  ORGANISATION_REGISTRATION_NUMBER_HELP_SITE_FRENCH:
    'https://apps.cra-arc.gc.ca/ebci/hacc/srch/pub/dsplyBscSrch',
  EIN_ONLINE_APPLICATION_URL: 'https://sa.www4.irs.gov/modiein/individual/index.jsp',
  PLAID_HELP_LINK: 'https://support-my.plaid.com/hc/en-us/categories/4405964085015-About-Plaid',
  PROBATE_INFORMATION_FORM_URL:
    'https://www.ontariocourts.ca/scj/files/forms/est/probate-information-form-EN.docx',
  QUEBEC_MARRIAGE_CONTRACT_REQUEST_URL:
    'https://www.etatcivil.gouv.qc.ca/publications/DCCA-Marriage_Civil_Union%202022-2023.pdf',
  TRUSTPILOT_REVIEW_BASE_URL: 'https://www.trustpilot.com/evaluate-link/',
  HUBSPOT_CHECKOUT_DOWNLOAD_CHECKLIST_URL:
    'https://8693223.fs1.hubspotusercontent-na1.net/hubfs/8693223/ClearEstate%20Kickoff%20Meeting%20Instructions.pdf',
  VITAL_STATISTICS_AGENCY_BRITISH_COLUMBIA:
    'https://www2.gov.bc.ca/gov/content/family-social-supports/seniors/health-safety/health-care-programs-and-services/vital-statistics'
};

export const LocalStorageKey = {
  TABLES: 'tables',
  ESTATE_OVERVIEW: 'estate_overview',
  USER_LOCALE: 'user_locale',
  USER_ID: 'user_id',
  REDIRECT_URL_FULL_PATH: 'redirect_url_full_path',
  BANNERS: 'banners',
  STANDARD_PLAN_NEEDS: 'standard_plan_needs',
  DISMISSED_MAINTENANCE_BANNER: 'dismissed_maintenance_banner',
  UNSUPPORTED_MOBILE_VIEW_WARNING_DISMISSED: 'unsupported_mobile_view_warning_dismissed',
  EHC_FINALIZED_MODAL_SEEN: 'ehc_finalized_modal_seen'
};

export const UIConfig = {
  UNDO_TIMEOUT: 5 * 1000 // milliseconds
};
